import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
@Pipe({
  name: 'safehtml',
})
export class SafehtmlPipe implements PipeTransform {
  sanitizer = inject(DomSanitizer);
  transform(value: string): unknown {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
